const VIEWPORT_OVERIDES = {
  viewportNorthEastLat: undefined,
  viewportNorthEastLong: undefined,
  viewportSouthWestLat: undefined,
  viewportSouthWestLong: undefined,
};

const POINT_OVERIDES = {
  locationLat: undefined,
  locationLong: undefined,
  locationSearchRadius: undefined,
};

export const getLocationStateForPoint = (name, point) => ({
  name,
  point,
  viewport: null,
});

export const getLocationStateForViewport = (name, viewport) => ({
  name,
  point: null,
  viewport,
});

const getEmptyLocationState = () => ({
  name: null,
  point: null,
  viewport: null,
});

export const getEmptyViewpointState = () => VIEWPORT_OVERIDES;

const toLocationPoint = ({
  locationLat,
  locationLong,
  locationSearchRadius,
}) => ({
  lat: locationLat,
  lng: locationLong,
  radius: locationSearchRadius,
});

const toLocationViewport = ({
  viewportNorthEastLat,
  viewportNorthEastLong,
  viewportSouthWestLat,
  viewportSouthWestLong,
}) => ({
  ne: {
    lat: viewportNorthEastLat,
    lng: viewportNorthEastLong,
  },
  sw: {
    lat: viewportSouthWestLat,
    lng: viewportSouthWestLong,
  },
});

const toSearchPoint = ({ lat, lng, radius }) => ({
  locationLat: lat,
  locationLong: lng,
  locationSearchRadius: radius,
});

export const toSearchViewport = ({ ne = {}, sw = {} } = {}) => ({
  viewportNorthEastLat: ne.lat,
  viewportNorthEastLong: ne.lng,
  viewportSouthWestLat: sw.lat,
  viewportSouthWestLong: sw.lng,
});

const getLocationFromQuery = (
  name,
  {
    locationLat,
    locationLong,
    locationSearchRadius,
    viewportNorthEastLat,
    viewportNorthEastLong,
    viewportSouthWestLat,
    viewportSouthWestLong,
  },
) => {
  // If a location point is present, prefer it. Only a location point or a viewport can be set.
  // Not both.
  if (locationLat && locationLong && locationSearchRadius) {
    const point = toLocationPoint({
      locationLat,
      locationLong,
      locationSearchRadius,
    });
    return getLocationStateForPoint(name, point);
  }

  // Set viewport location.
  if (
    viewportNorthEastLat &&
    viewportNorthEastLong &&
    viewportSouthWestLat &&
    viewportSouthWestLong
  ) {
    const viewport = toLocationViewport({
      viewportNorthEastLat,
      viewportNorthEastLong,
      viewportSouthWestLat,
      viewportSouthWestLong,
    });
    return getLocationStateForViewport(name, viewport);
  }

  return null;
};

export const getLocationStateFromCategoryData = (
  // categoryData
  { location: { city, state, country } = {}, query: categoryQuery = {} } = {},
  // router query
  urlQuery,
) => {
  // Location name
  const name = urlQuery.selectedLocationName || city || state || country;

  const isLocationNameSameAsCategoryLocation =
    name === country || name === state || name === city;

  // Prefer the url query if it has a specific override of the category location.
  const urlLocation = getLocationFromQuery(name, urlQuery);
  if (urlLocation) {
    return {
      location: urlLocation,
      // Indicate that the user has explicitly set this location
      isLocationSetByUser: !isLocationNameSameAsCategoryLocation,
    };
  }

  const categoryLocation = getLocationFromQuery(name, categoryQuery);
  if (categoryLocation) {
    return {
      location: categoryLocation,
      isLocationSetByUser: false,
    };
  }

  return {
    location: getEmptyLocationState(),
    isLocationSetByUser: false,
  };
};

export const getSearchParamsFromLocation = ({ name, point, viewport } = {}) => {
  if (point) {
    return {
      selectedLocationName: name,
      // Ensure search viewpoint url vars are overriden if they are in the query.
      ...VIEWPORT_OVERIDES,
      ...toSearchPoint(point),
    };
  }
  if (viewport) {
    return {
      selectedLocationName: name,
      // Ensure search point url vars are overriden if they are in the query.
      ...POINT_OVERIDES,
      ...toSearchViewport(viewport),
    };
  }
  return {};
};
